import {
  Avatar,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  IconButton,
  Paper,
  Radio,
  Switch,
  TextField,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import AppButton from "../shares/AppButton";
import { useTheme, useMediaQuery } from "@mui/material";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import { AssociationService } from "../../../service/AssociationService";
import { enleverBaliseHtml, isValidEmail } from "../../../Helpers/utilsHelper";
import { CloseOutlined, EditOutlined } from "@material-ui/icons";
import { uploadService } from "../../../service/UploadService";
import StandardSkeletoon from "../shares/loader/StandardSkeletoon";

const INIT_MEMBRE = {
  asso_uuid: null,
  user_data: {
    nom: "",
    prenoms: "",
    sexe: "",
    adresse: "",
    telephone: "",
    email2: "",
    annee_naissance: "",
    photo: null,
  },
  membre_params: {
    autorized: "0",
    role: 1,
    role_responsable: "",
  },
};

const INIT_FORM_ERROR = {
  nom_error: null,
  prenoms_error: null,
  sexe_error: null,
  adresse_error: null,
  telephone_error: null,
  mail_error: null,
  fonction_orror: null,
};
const MembreForm = ({
  open,
  onFormClose,
  onFormOpen,
  idMembre,
  association_uuid,
}) => {
  const [currentMembre, setCurrentMembre] = useState(INIT_MEMBRE);
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [isSubmited, setIsSubmited] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [photoDeMembre, setPhotoMembre] = useState(null);
  const { Toast, showToast } = useToast();

  const handleFormClose = () => {
    onFormClose();
    initAll();
  };

  const initAll = () => {
    setPhotoMembre(null);
    setCurrentMembre(INIT_MEMBRE);
    setFormErrors(INIT_FORM_ERROR);
    setIsSubmited(false);
  };

  const handleChangeMembreIdentite = (e) => {
    const { name, value } = e.target;
    let user_data = currentMembre.user_data;
    let user_id = { ...user_data, [name]: value };
    setCurrentMembre({ ...currentMembre, user_data: user_id });
  };
  const handleChangeMembreParams = (e) => {
    const { name, value } = e.target;
    let membre_params = currentMembre.membre_params;
    let user_params = { ...membre_params, [name]: value };
    setCurrentMembre({ ...currentMembre, membre_params: user_params });
  };

  const handleFetchCurrentMembre = () => {
    if (idMembre) {
      setFormLoading(true);
      AssociationService.findOneMembre(idMembre)
        .then((res) => {
          if (res && res.success) {
            setCurrentMembre(formatToCompatibleData(res.data));
            setPhotoMembre({
              ...photoDeMembre,
              photo_link: res.data.photo_link,
            });
          } else {
            setCurrentMembre(INIT_MEMBRE);
          }
        })
        .finally(() => {
          setFormLoading(false);
        });
    } else {
      setCurrentMembre(INIT_MEMBRE);
    }
  };

  const handleCheckDataValidation = () => {
    setFormErrors({
      adresse_error: !currentMembre.user_data.adresse ? "Adresse requis" : null,
      nom_error: !currentMembre.user_data.nom ? "Nom requis" : null,
      annee_naissance_error: !currentMembre.user_data.annee_naissance
        ? "Année de naissance requise"
        : new Date().getFullYear() -
              Number(currentMembre.user_data.annee_naissance) >
            100
          ? "Verifier votre année de naissance"
          : null,
      sexe_error: !currentMembre.user_data.sexe ? "Sexe requis" : null,
      mail_error:
        currentMembre.user_data.email &&
        !isValidEmail(currentMembre.user_data.email)
          ? "Email non valide"
          : null,
      fonction_orror: !currentMembre.membre_params.role_responsable
        ? "Fonction requise"
        : null,
    });
    return Object.values(formErrors).every((item) => item === null);
  };

  const handleAddNew = () => {
    setSubmitting(true);
    AssociationService.addMembre({
      ...currentMembre,
      asso_uuid: association_uuid,
    })
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleUpdate = () => {
    setSubmitting(true);
    AssociationService.updateMembre({
      ...currentMembre,
      asso_uuid: association_uuid,
    })
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleSubmit = () => {
    setIsSubmited(true);
    if (handleCheckDataValidation()) {
      if (idMembre) {
        handleUpdate();
      } else {
        handleAddNew();
      }
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  const handleSetMembreToAuthorized = (val) => {
    let membre_params = currentMembre.membre_params;
    membre_params.autorized = val;
    setCurrentMembre({ ...currentMembre, membre_params: membre_params });
  };

  const formatToCompatibleData = (data) => {
    return {
      asso_uuid: association_uuid,
      user_data: {
        id_ext_user: data.id_ext_user,
        uuid: data.uuid,
        nom: data.nom,
        prenoms: data.prenoms,
        sexe: data.sexe,
        adresse: data.adresse,
        telephone: data.telephone1,
        email2: data.email2,
        annee_naissance: data.annee_naissance,
        photo: data.photo,
      },
      membre_params: {
        autorized: data.autorized,
        role: data.role,
        role_responsable: data.role_responsable,
        id_ext_responsable_association: data.id_ext_responsable_association,
      },
    };
  };

  const handleFileUpload = (file) => {
    setFormErrors({
      ...formErrors,
      logo_error: "Telechargement du fichier en cours...",
    });
    uploadService
      .uploadFile(file)
      .then((res) => {
        if (!(res && res.success)) {
          showToast(TYPE_NOTIFICATION.ERROR, enleverBaliseHtml(res.error));
        } else {
          handleChangeMembreIdentite({
            target: { name: "photo", value: res.data.file_name },
          });
          setFormErrors({
            ...formErrors,
            photo_error:
              res && res.success ? null : enleverBaliseHtml(res.error),
          });
          setPhotoMembre({ ...photoDeMembre, photo_link: res.data.link });
        }
      })
      .finally(() => {
        setFormErrors({
          ...formErrors,
          photo_error: null,
        });
      });
  };

  useEffect(() => {
    if (photoDeMembre && photoDeMembre?.name) {
      handleFileUpload(photoDeMembre);
    }
  }, [photoDeMembre]);

  useEffect(() => {
    handleFetchCurrentMembre();
  }, [open, idMembre]);

  useEffect(() => {
    if (currentMembre) {
      handleCheckDataValidation();
    }
  }, [currentMembre]);

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md")); //à partir de taille md

  const fileInputRef = useRef(null);

  const handleEditPhoto = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPhotoMembre(file);
      setCurrentMembre({ ...currentMembre, photo: file.name });
    }
  };

  return (
    <>
      <Toast />
      <Dialog open={open} onClose={handleFormClose} maxWidth="md">
        <Paper sx={{ m: 3 }} elevation={0}>
          <Grid>
            <CardHeader
              title={idMembre ? "Modifier membre" : "Nouveau membre"}
              sx={{ mb: -2, mt: -2 }}
            />
            <Grid item width={"100%"} display={formLoading ? "" : "none"}>
              <StandardSkeletoon
                show={formLoading}
                row={4}
                col={1}
                escalier={true}
                m={2}
              />
            </Grid>
            <Grid
              maxHeight={"75vh"}
              display={formLoading ? "none" : ""}
              overflow="auto"
            >
              {currentMembre && !formLoading && (
                <CardContent>
                  <Grid item>
                    <CardHeader
                      avatar={
                        <Grid display={"flex"} flexDirection={"column"}>
                          <Grid mt={-2} display={"flex"} flexDirection={"row"}>
                            <Avatar
                              variant="rounded"
                              sx={{
                                m: 1,
                                width: "clamp(100px, 15vw, 150px)",
                                height: "clamp(100px, 15vw, 150px)",
                                fontSize: "clamp(40px, 8vw, 80px)",
                                borderColor: formErrors.photo_error
                                  ? "error.main"
                                  : "text.primary",
                              }}
                              alt={currentMembre.nom || "Asso"}
                              src={
                                photoDeMembre?.photo_link ||
                                currentMembre.photo_link
                              }
                            />
                            <Grid
                              display={"flex"}
                              height={"100%"}
                              ml={-11}
                              mt={1}
                              flexDirection={"row"}
                              alignItems={"start"}
                            >
                              <IconButton
                                sx={{
                                  "&:hover": {
                                    color: "red",
                                  },
                                }}
                                onClick={handleEditPhoto}
                              >
                                <EditOutlined />
                              </IconButton>
                              <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                              />
                              <IconButton
                                sx={{
                                  display: "none",
                                  "&:hover": {
                                    color: "red",
                                  },
                                }}
                              >
                                <CloseOutlined />
                              </IconButton>
                            </Grid>
                          </Grid>
                          <FormHelperText
                            sx={{
                              display: formErrors.logo_error ? "flex" : "none",
                              color: "error.main",
                            }}
                            id="photo_helper"
                          >
                            {formErrors.logo_error}
                          </FormHelperText>
                        </Grid>
                      }
                    />
                    <Grid
                      container
                      overflow={"auto"}
                      direction={isMdUp ? "row" : "column"}
                    >
                      <Grid item mb={1} xs={12} md={6}>
                        <Grid item m={1.5}>
                          <FormControl fullWidth>
                            <label>Nom *</label>
                            <TextField
                              id="nom"
                              name="nom"
                              onChange={handleChangeMembreIdentite}
                              size="small"
                              type="text"
                              placeholder="Nom"
                              value={currentMembre.user_data.nom || ""}
                              error={formErrors.nom_error && isSubmited}
                              helperText={
                                isSubmited ? formErrors.nom_error : ""
                              }
                              fullWidth
                              aria-describedby="nom_helper"
                            />
                            <FormHelperText id="nom_helper"></FormHelperText>
                          </FormControl>
                          <FormControl fullWidth>
                            <label>Prenoms</label>
                            <TextField
                              id="prenoms"
                              name="prenoms"
                              onChange={handleChangeMembreIdentite}
                              size="small"
                              type="text"
                              value={currentMembre.user_data.prenoms || ""}
                              error={formErrors.prenoms_error && isSubmited}
                              helperText={
                                isSubmited ? formErrors.prenoms_error : ""
                              }
                              placeholder="Prenoms"
                              fullWidth
                              aria-describedby="prenoms_helper"
                            />
                            <FormHelperText id="prenoms_helper"></FormHelperText>
                          </FormControl>
                          <FormControl fullWidth>
                            <label>Année de naissance *</label>
                            <TextField
                              id="annee_naissance"
                              name="annee_naissance"
                              onChange={handleChangeMembreIdentite}
                              value={
                                currentMembre.user_data.annee_naissance || ""
                              }
                              size="small"
                              type="number"
                              error={
                                formErrors.annee_naissance_error && isSubmited
                              }
                              helperText={
                                isSubmited
                                  ? formErrors.annee_naissance_error
                                  : ""
                              }
                              placeholder="Année de naissance"
                              fullWidth
                              aria-describedby="annee_naissance_helper"
                            />
                            <FormHelperText id="annee_naissance_helper"></FormHelperText>
                          </FormControl>
                          <FormControl fullWidth>
                            <label>Sexe</label>
                            <FormGroup
                              row
                              defaultValue={"M"}
                              onChange={handleChangeMembreIdentite}
                              sx={{ ml: 1 }}
                            >
                              <FormControlLabel
                                // required
                                value={"M"}
                                name="sexe"
                                control={<Radio />}
                                label="Masculin"
                                checked={currentMembre.user_data.sexe === "M"}
                              />
                              <FormControlLabel
                                // required
                                value={"F"}
                                name="sexe"
                                control={<Radio />}
                                label="Feminin"
                                checked={currentMembre.user_data.sexe === "F"}
                              />
                            </FormGroup>
                            <FormHelperText id="sexe_helper"></FormHelperText>
                          </FormControl>
                          <FormControl fullWidth>
                            <label>Adresse</label>
                            <TextField
                              id="adresse"
                              name="adresse"
                              onChange={handleChangeMembreIdentite}
                              size="small"
                              type="text"
                              value={currentMembre.user_data.adresse || ""}
                              error={formErrors.adresse_error && isSubmited}
                              helperText={
                                isSubmited ? formErrors.adresse_error : ""
                              }
                              placeholder="Adresse"
                              fullWidth
                              aria-describedby="adresse_helper"
                            />
                            <FormHelperText id="adresse_helper"></FormHelperText>
                          </FormControl>
                          <FormControl fullWidth>
                            <label>Telephone *</label>
                            <TextField
                              id="telephone"
                              name="telephone"
                              onChange={handleChangeMembreIdentite}
                              size="small"
                              type="text"
                              value={currentMembre.user_data.telephone || ""}
                              error={formErrors.telephone_error && isSubmited}
                              helperText={
                                isSubmited ? formErrors.telephone_error : ""
                              }
                              placeholder="Téléphone du membre"
                              fullWidth
                              aria-describedby="telephone_helper"
                            />
                            <FormHelperText id="telephone_helper"></FormHelperText>
                          </FormControl>
                          <FormControl fullWidth>
                          <label>Email</label>
                          <TextField
                            id="email2"
                            name="email2"
                            onChange={handleChangeMembreIdentite}
                            size="small"
                            type="email"
                            value={currentMembre.user_data.email2 || ""}
                            error={formErrors.mail_error && isSubmited}
                            helperText={isSubmited ? formErrors.mail_error : ""}
                            placeholder="Email du membre"
                            fullWidth
                            aria-describedby="email_helper"
                          />
                          <FormHelperText id="email_helper"></FormHelperText>
                        </FormControl>
                        </Grid>
                      </Grid>
                      {/* <Divider
                  orientation={isMdUp ? "vertical" : "horizontal"}
                  flexItem
                  sx={{ mx: isMdUp ? 2 : 0, my: isMdUp ? 0 : 2 }}
                /> */}
                      <Grid item xs={12} mb={1} md={6}>
                        <Grid m={1.5}>
                          <FormControl fullWidth>
                            <label>Fonction *</label>
                            <TextField
                              id="role_responsable"
                              name="role_responsable"
                              onChange={handleChangeMembreParams}
                              size="small"
                              type="text"
                              value={
                                currentMembre.membre_params.role_responsable ||
                                ""
                              }
                              error={formErrors.fonction_orror && isSubmited}
                              helperText={
                                isSubmited ? formErrors.fonction_orror : ""
                              }
                              placeholder="Fonction du membre"
                              fullWidth
                              aria-describedby="fonction_helper"
                            />
                            <FormHelperText id="fonction_helper"></FormHelperText>
                          </FormControl>
                          <FormControl fullWidth sx={{ display: "none" }}>
                            <FormGroup sx={{ mt: 3, ml: 1 }}>
                              <FormControlLabel
                                /*  disabled={
                              currentMembre.user_data.id_ext_user ===
                              AuthService.getUserInfo().id_ext_user
                            } */
                                name="autorized"
                                control={<Switch />}
                                label={
                                  (currentMembre.membre_params.autorized === "1"
                                    ? "Autorisé"
                                    : " Non autorisé") +
                                  " à gerer l'association"
                                }
                                onChange={(e) =>
                                  handleSetMembreToAuthorized(
                                    e.target.checked ? "1" : "0"
                                  )
                                }
                                checked={
                                  currentMembre.membre_params.autorized === "1"
                                }
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              )}
            </Grid>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                loading={submitting}
                text={"Enregistrer"}
                variant={"contained"}
                size={"medium"}
                onClick={(e) => handleSubmit()}
              />
              <AppButton
                size={"medium"}
                text={"Fermer"}
                variant={"outlined"}
                onClick={(e) => handleFormClose()}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default MembreForm;
